import { useInstallPWA } from '@/hooks/useInstallPWA'
import styles from './InstallPWA.module.css'

// Inline download icon — no icon lib dependency
function DownloadIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
      <polyline points="7 10 12 15 17 10"/>
      <line x1="12" y1="15" x2="12" y2="3"/>
    </svg>
  )
}

function XIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
      <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
    </svg>
  )
}

// ── Navbar install button (desktop) ──────────────────────────────────────────
export function NavInstallButton() {
  const { isInstallable, install } = useInstallPWA()
  if (!isInstallable) return null
  return (
    <button onClick={install} className={styles.navBtn} title="Install NexusAI app">
      <DownloadIcon /> Install App
    </button>
  )
}

// ── Bottom banner (mobile) ────────────────────────────────────────────────────
export default function InstallPWABanner() {
  const { isInstallable, install, dismiss } = useInstallPWA()
  if (!isInstallable) return null

  return (
    <div className={styles.banner} role="banner" aria-label="Install NexusAI app">
      <div className={styles.bannerInner}>
        <img src="/pwa-icon-192.svg" alt="" className={styles.icon} />
        <div className={styles.text}>
          <p className={styles.title}>Install NexusAI</p>
          <p className={styles.sub}>Add to home screen for instant access</p>
        </div>
        <div className={styles.actions}>
          <button onClick={install} className={styles.installBtn}>
            <DownloadIcon /> Install
          </button>
          <button onClick={dismiss} className={styles.dismissBtn} aria-label="Dismiss">
            <XIcon />
          </button>
        </div>
      </div>
    </div>
  )
}
